<template>
  <div class="admin-CA-setting">
    
    
    <div class="header">
      <h2>보장분석 설정</h2>
    </div>

    <dialog_boardPicker v-if="use_boardPicker" @submit="handleBoardPicker"/>

    <div class="dialog" v-if="use_dialog">
      <span class="close" @click="openDialog(false)"></span>
      <div 
        class="paper edit-ex-cov" 
        v-if="editing_ex_cov"
        :style="{ left: dialogPosition.x + 'px', top: dialogPosition.y + 'px' }"
      >
        <div 
          class="dialog-header" 
          @mousedown="startDrag"
        >
          <h2>{{ editing_ex_cov?.idx ? '보장항목 수정' : '보장항목 생성' }}</h2>
          <button class="close-btn" @click="openDialog(false)">
            <i class="ph ph-x"></i>
          </button>
        </div>
        <ul>
          <li>
            <span>순서 <button @click="checkNoDuplicate">중복확인</button> </span>
            <input type="number" min="0" placeholder="0" v-model="editing_ex_cov.no"/>
          </li>
          <li>
            <span>대표 이름 <button @click="checkNameDuplicate">중복확인</button></span>
            <input type="text" placeholder="ex) 상해사망" v-model="editing_ex_cov.name"/>
            <span style="position: absolute; width:fit-content !important; right:16px; top:55%; opacity: 0.6; font-size:16px; text-align: end;">{{ editing_ex_cov.name.length }}</span>
          </li>
          <li>
            <span>전체 이름</span>
            <input type="text" placeholder="ex) 상사" v-model="editing_ex_cov.long_name"/>
          </li>
          <li>
            <span>압축 이름</span>
            <input type="text" placeholder="ex) 상사" v-model="editing_ex_cov.short_name"/>
            <span style="position: absolute; width:fit-content !important; right:16px; top:55%; opacity: 0.6; font-size:16px; text-align: end;">{{ editing_ex_cov.short_name.length }}</span>
          </li>
          <li>
            <div style="display:flex; gap:12px; width:100%; justify-content: center; align-items: center;">
              <label title="부모 챕터">대분류</label>
              <select v-model="watching_parent_chapter" style="flex:1;">
                <option v-for="chapter in IS_chapter_onlyParent" :key="chapter.idx" :value="chapter.idx">{{ chapter.name }}</option>
              </select>

              <label title="자식 챕터">소분류</label>
              <select v-model="editing_ex_cov.chapter_id" style="flex:1;">
                <template v-for="chapter in IS_chapter_onlyChild" :key="chapter.idx">
                  <option v-if="chapter.parent === watching_parent_chapter" :value="chapter.idx">{{ chapter.name }}</option>
                </template>
              </select>
            </div>

          </li>
          <li>
            <div style="display:flex; gap:12px; width:100%; justify-content: center; align-items: center;">
              <label>부모유닛</label>
              <select style="flex:1;" v-model="editing_ex_cov.parent">
                <option value="0">없음</option>
                <option v-for="ex_cov in unionExCovList" :key="ex_cov.idx" :value="ex_cov.idx" :title="ex_cov.no">{{ ex_cov.name }}</option>
              </select>
              <label>직접선택</label>
              <select style="flex:1;" v-model="editing_ex_cov.parent">
                <option value="0">없음</option>
                <option v-for="ex_cov in notUnionExCovList" :key="ex_cov.idx" :value="ex_cov.idx" :title="ex_cov.no">{{ ex_cov.name }}</option>
              </select>
            </div>
          </li>
          <li>
            <span>일반 옵션</span>
            <div style="display:flex; gap:12px; width:100%; justify-content: start; align-items: center; flex-direction: row; flex:wrap;">
              <div style="display:flex; justify-content: center; align-items: center; padding:6px; border-radius: 6px; background:var(--color-background-light); ">
                <label style="color:var(--color-brand)" for="is_union" title="이 유닛을 대표로 함">대표유닛</label>
                <input type="checkbox" id="is_union" v-model="editing_ex_cov.is_union" :true-value="1" :false-value="0"/>
              </div>
              <div style="display:flex; justify-content: center; align-items: center; padding:6px; border-radius: 6px; background:var(--color-background-light);">
                <label for="sel" title="이 유닛을 기본으로 보이게 함">기본체크</label>
                <input type="checkbox" id="sel" v-model="editing_ex_cov.sel" :true-value="1" :false-value="0"/>
              </div>
              <div style="display:flex; justify-content: center; align-items: center; padding:6px; border-radius: 6px; background:var(--color-background-light);">
                <label for="calculable" title="이 유닛을 합산에 포함함">합산포함</label>
                <input type="checkbox" id="calculable" v-model="editing_ex_cov.calculable" :true-value="1" :false-value="0"/>
              </div>
              <div style="display:flex; justify-content: center; align-items: center; padding:6px; border-radius: 6px; background:var(--color-background-light);">
                <label for="low_show" title="이 유닛을 합산에 포함함">미표시</label>
                <input type="checkbox" id="low_show" v-model="editing_ex_cov.low_show" :true-value="1" :false-value="0"/>
              </div>
            </div>
          </li>
          <li >
            <span>검색 옵션</span>
            <div style="display:flex; gap:12px; width:100%; justify-content: start; align-items: center; flex-direction: row; flex:wrap;">
              <div style="display:flex; justify-content: center; align-items: center; padding:6px; border-radius: 6px; background:var(--color-background-light);">
                <label for="searchable" title="이 유닛을 검색시 노출">검색노출</label>
                <input type="checkbox" id="searchable" v-model="editing_ex_cov.searchable" :true-value="1" :false-value="0"/>
              </div>
              <div style="display:flex; justify-content: center; align-items: center; padding:6px; border-radius: 6px; background:var(--color-background-light);">
                <label for="suggestion" >우선검색</label>
                <input type="checkbox" id="suggestion" v-model="editing_ex_cov.suggestion" :true-value="1" :false-value="0"/>
              </div>
            </div>
          </li>
          <li>
            <span>꾸미기 옵션</span>
            <div style="display:flex; gap:12px; width:100%; justify-content: start; align-items: center; flex-direction: row; flex:wrap;">
              <div style="display:flex; justify-content: center; align-items: center; padding:6px; border-radius: 6px; background:var(--color-background-light);">
                <label for="style_important">흐리게</label>
                <input type="checkbox" id="style_important" v-model="editing_ex_cov.style_important" :true-value="1" :false-value="0"/>
              </div>
              <div style="display:flex; justify-content: center; align-items: center; padding:6px; border-radius: 6px; background:var(--color-background-light);">
                <label for="style_bold">진하게</label>
                <input type="checkbox" id="style_bold" v-model="editing_ex_cov.style_bold" :true-value="1" :false-value="0"/>
              </div>
            </div>
          </li>
          <li>
            <span>태그</span>
            <input type="text" placeholder="ex) 상해|사망" v-model="editing_ex_cov.tags"/>
          </li>
          <li>
            <span>한 줄 설명</span>
            <textarea v-model="editing_ex_cov.description"></textarea>
          </li>
          <li>
            <span>보상예시</span>
            <div class="benefit-type-selector">
              <label v-for="benefit in benefit_ex_list" :key="benefit.idx" class="benefit-checkbox">
                <input 
                  type="checkbox" 
                  :value="benefit.idx" 
                  :checked="isBenefitSelected(benefit.idx)"
                  @change="toggleBenefitType(benefit.idx)"
                />
                <span>{{ benefit.name }}</span>
              </label>
            </div>
          </li>
          <li>
            <span>BCM</span>
            <input type="number" placeholder="0" v-model="editing_ex_cov.r_bcm"/>
          </li>
          <li>
            <span>BCR</span>
            <input type="number" placeholder="0" v-model="editing_ex_cov.r_bcr"/>
          </li>
          <li>
            <span>NCR</span>
            <input type="number" placeholder="0" v-model="editing_ex_cov.r_ncr"/>
          </li>
          <li>
            <span>N</span>
            <input type="number" placeholder="0" v-model="editing_ex_cov.r_n"/>
          </li>
          <li>
            <span>WBS</span>
            <input type="number" placeholder="0" v-model="editing_ex_cov.r_wbs"/>
          </li>
          <li>
            <span>BIA</span>
            <input type="number" placeholder="0" v-model="editing_ex_cov.r_bia"/>
          </li>
          <li>
            <span>W</span>
            <input type="number" placeholder="0" v-model="editing_ex_cov.r_w"/>
          </li>
        </ul>
        <div class="btns">
          <button @click="openDialog(false)">닫기</button>
          <button class="a" @click="saveEditingExCov">저장</button>
        </div>
      </div>
    </div>


    <div class="content">
      
      <div class="item IS_ex_coverage">
        <div class="header">
          <div> <h2>보장항목(챕터) 관리</h2> </div>
          <div style="display: flex; gap: 12px; align-items: center;">
            <div class="search-box">
              <i class="ph ph-magnifying-glass"></i>
              <input 
                type="text" 
                v-model="searchKeyword" 
                placeholder="이름, 태그로 검색..."
                @input="filterExCoverage"
              />
              <button v-if="searchKeyword" @click="clearSearch" class="clear-btn">
                <i class="ph ph-x"></i>
              </button>
            </div>
            <button id="btn_add" @click="openEditExCovDialog(true, null)" >추가</button>
          </div>
        </div>
        
        <div class="hot_bar">
          <div class="all">
            <input type="checkbox" id="chk_all" v-model="showAllChapters" @change="toggleAllChapters" />
            <label for="chk_all">전체</label>
          </div>
          <div class="con">
            <ul v-for="(chapter,i) in IS_chapter_onlyParent" :key="i">
              <li>
                <span>{{ chapter.name }}</span>
                <div>
                  <div v-for="(child, idx) in IS_chapter_onlyChild.filter(ch => ch.parent === chapter.idx)" :key="idx">
                    <input type="checkbox" :id="child.idx" v-model="child.ed_vis" :true-value="1" :false-value="0" />
                    <label :for="child.idx">{{ child.name }}</label>
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </div>

        <div class="guide">
          <span style="flex:0.6;">순서</span>
          <span style="flex:1.1;">소속챕터</span>
          <span style="flex:1.2;">부모</span>
          <span style="flex:2;">이름</span>
          <span style="flex:1;">보장예시<small style="color:var(--color-surface-reverse); font-size:12px;">(유형)</small></span>
          <span style="flex:0.6;">기본체크</span>
          <span style="flex:0.6;">합산포함</span>
          <span style="flex:0.6;">검색노출</span>
          <span style="flex:0.6;">우선검색</span>
          <span style="flex:0.6;">흐리게</span>
          <span style="flex:0.6;">볼드</span>
          <span style="flex:1;">연결된 게시물</span>
          <span style="flex:0.8;">[[관리]]</span>
        </div>
        <ul>
          <template v-for="ex_cov in filteredExCoverage" :key="ex_cov.idx">
            <li v-if="getChapterById(ex_cov.chapter_id)?.ed_vis">
              <span @click="openEditExCovDialog(true, ex_cov)" style="flex:0.6; justify-content:start!important; color:var(--color-surface-reverse)">&nbsp;&nbsp;{{ ex_cov.no }}</span>
              <span @click="openEditExCovDialog(true, ex_cov)" style="flex:1.1; justify-content:start!important;" :code="ex_cov.chapter_id">&nbsp;&nbsp;{{ getChapterById(ex_cov.chapter_id)?.name }}</span>

              <span v-if="ex_cov.is_union" @click="openEditExCovDialog(true, ex_cov)" style="flex:1.2; justify-content:start!important; color:var(--color-brand)">&nbsp;&nbsp;대표유닛</span>
              <span v-if="!ex_cov.is_union" @click="openEditExCovDialog(true, ex_cov)" style="flex:1.2; justify-content:start!important;">&nbsp;&nbsp;{{ IS_ex_coverage?.find(cov => cov.idx === ex_cov.parent)?.name || '--' }} </span>
              
              <span @click="openEditExCovDialog(true, ex_cov)" style="flex:2; justify-content:start!important;">&nbsp;&nbsp;{{ ex_cov.name }}<small style="padding-left:6px; height:60%; display:flex; color:var(--color-surface-reverse)">({{ ex_cov.short_name }})</small></span>
              <span @click="openEditExCovDialog(true, ex_cov)" style="flex:1; color:var(--color-surface-reverse)" :title="getBenefitTypeNames(ex_cov.benefit_type)">{{ getBenefitTypeNamesOnlyFirstLetter(ex_cov.benefit_type) }}</span>
              <span @click="openEditExCovDialog(true, ex_cov)" style="flex:0.6;" :style="{ color: ex_cov.sel ? '#4063FF' : 'var(--color-surface-reverse)' }" >{{ ex_cov.sel ? 'O' : '-' }}</span>
              <span @click="openEditExCovDialog(true, ex_cov)" style="flex:0.6;" :style="{ color: ex_cov.calculable ? '#4063FF' : 'var(--color-surface-reverse)' }" >{{ ex_cov.calculable ? 'O' : '-' }}</span>
              <span @click="openEditExCovDialog(true, ex_cov)" style="flex:0.6;" :style="{ color: ex_cov.searchable ? '#4063FF' : 'var(--color-surface-reverse)' }" >{{ ex_cov.searchable ? 'O' : '-' }}</span>
              <span @click="openEditExCovDialog(true, ex_cov)" style="flex:0.6;" :style="{ color: ex_cov.suggestion ? '#4063FF' : 'var(--color-surface-reverse)' }" >{{ ex_cov.suggestion ? 'O' : '-' }}</span>
              <span @click="openEditExCovDialog(true, ex_cov)" style="flex:0.6;" :style="{ color: ex_cov.style_important ? '#4063FF' : 'var(--color-surface-reverse)' }" >{{ ex_cov.style_important ? 'O' : '-' }}</span>
              <span @click="openEditExCovDialog(true, ex_cov)" style="flex:0.6;" :style="{ color: ex_cov.style_bold ? '#4063FF' : 'var(--color-surface-reverse)' }" >{{ ex_cov.style_bold ? 'O' : '-' }}</span>
              <span @click="showBoardPicker(true, ex_cov)" style="flex:1;">
                <div v-if="ex_cov.linked_ref" style="color:var(--color-surface-reverse)"> {{ boardInfos.find(info => info.idx == ex_cov.linked_ref)?.title.slice(0,5) + '...' || '--' }} </div>
              </span>
              <span style="flex:0.8; display: flex; gap: 4px; justify-content: center;"> 
                <button class="copy" @click="copyExCov(ex_cov)" title="복제"><i class="ph ph-copy"></i></button>
                <button class="remove" @click="delExCov(ex_cov)" title="삭제"><i class="ph ph-trash"></i></button> 
              </span>
            </li>
          </template>
        </ul>
      </div>


    </div>

    
  </div>
</template>


<script>
import { ref, inject, toRaw } from "vue";

import dialog_boardPicker from "@/components/dialogs/boardPicker.vue";

export default {
  components: {
    dialog_boardPicker
  },
  setup() {
    const sql_query = inject('sql_query');
    const getMbid = inject('getMbid');

    const editing_ex_cov = ref(null);
    const use_dialog = ref(false);
    const use_boardPicker = ref(false);
    
    const IS_ex_coverage = ref([]);
    const IS_ex_coverage_filtered = ref([]);
    const IS_chapter = ref([]);
    const IS_chapter_onlyChild = ref([]);
    const IS_chapter_onlyParent = ref([]);

    const watching_parent_chapter = ref(null);
    const benefit_ex_list = ref([]);
    const boardInfos = ref([]);
    const showAllChapters = ref(true);
    const unionExCovList = ref([]);
    const notUnionExCovList = ref([]);
    const selectedParentExCov = ref(null);
    const searchKeyword = ref('');
    const filteredExCoverage = ref([]);
    
    const dialogPosition = ref({ x: 0, y: 0 });
    const isDragging = ref(false);
    const dragStart = ref({ x: 0, y: 0 });

    function toggleAllChapters() {
      IS_chapter_onlyChild.value.forEach(ch => {
        ch.ed_vis = showAllChapters.value ? 1 : 0;
      });
    }

    async function handleBoardPicker(postidx) {
      use_boardPicker.value = false;
      if (postidx === null) {
        editing_ex_cov.value.linked_ref = null;
      } else {
        await sql_query(`UPDATE IS_ex_coverage SET linked_ref = '${postidx}' WHERE idx = '${editing_ex_cov.value.idx}'`);
        editing_ex_cov.value = false;
        // reload
        fetchData();
      }
      // 게시물 선택 후, 대화창 닫기
      openDialog(false);
    }

    async function getBoardInfoByIdx(idx) {
      const res = await sql_query(`SELECT * FROM board_reference WHERE idx = '${idx}'`);
      if (res && res.length > 0) {
        // 중복 방지
        if (!boardInfos.value.some(info => info.idx === res[0].idx)) {
          boardInfos.value.push(res[0]); // 첫 행만 추가
        }
      }
    }

    function showBoardPicker(bool, ex_cov) {
      use_boardPicker.value = true;
      editing_ex_cov.value = ex_cov;
      if(!bool) { 
        use_boardPicker.value = false;
        editing_ex_cov.value = false;
      }
    }

    /*
    const IS_coverage = ref([]);
    const IS_plan = ref([]);
    const IS_solution = ref([]);
    const insu_company = ref([]);
    */

    async function getBenefitExList() {
      const res = await sql_query('SELECT * FROM benefit_ex order by no asc');
      benefit_ex_list.value = res;
    }
    getBenefitExList();

    async function fetchData() {
      const previousEdVis = Object.fromEntries(IS_chapter.value.map(ch => [ch.idx, ch.ed_vis]));

      IS_ex_coverage.value = await sql_query('SELECT * FROM IS_ex_coverage order by no asc ');
      IS_ex_coverage_filtered.value = JSON.parse(JSON.stringify(IS_ex_coverage.value));

      const rawChapters = await sql_query('SELECT * FROM IS_chapter');
      IS_chapter.value = rawChapters
        .map(ch => ({
          ...ch,
          ed_vis: previousEdVis[ch.idx] !== undefined ? previousEdVis[ch.idx] : 1
        }))
        .sort((a, b) => {
          // 1차 기준: 부모 idx (null은 위로)
          if (!a.parent && b.parent) return -1;
          if (a.parent && !b.parent) return 1;
          if (a.parent !== b.parent) return a.parent - b.parent;
          // 2차 기준: 그룹 내 순서
          return a.no - b.no;
        });


        IS_chapter_onlyParent.value = IS_chapter.value.filter(ch => ch.depth === 0);
        IS_chapter_onlyChild.value  = IS_chapter.value.filter(ch => ch.depth <= 1 && ch.parent); // 1단계만


      sortExCoverageList();
      unionExCovList.value = IS_ex_coverage.value.filter(cov => cov.is_union);
      notUnionExCovList.value = IS_ex_coverage.value.filter(cov => !cov.is_union);
      
      // 검색 필터 초기화
      filterExCoverage();
    }
    fetchData();


    // 챕터 기준 정렬
    function sortExCoverageList() {
      const getChapter = (id) => IS_chapter.value.find(c => c.idx === id);
      const getChapterNo = (id) => getChapter(id)?.no || 0;
      const getChapterParentNo = (id) => {
        const ch = getChapter(id);
        return ch && ch.parent ? getChapter(ch.parent)?.no || 0 : 0;
      };

      IS_ex_coverage_filtered.value.sort((a, b) => {
        const aParentNo = getChapterParentNo(a.chapter_id);
        const bParentNo = getChapterParentNo(b.chapter_id);

        const aChapterNo = getChapterNo(a.chapter_id);
        const bChapterNo = getChapterNo(b.chapter_id);

        const aParentCov = a.parent ? IS_ex_coverage.value.find(c => c.idx === a.parent) : null;
        const bParentCov = b.parent ? IS_ex_coverage.value.find(c => c.idx === b.parent) : null;

        const aKey = [
          String(aParentNo).padStart(3, '0'),
          String(aChapterNo).padStart(3, '0'),
          aParentCov?.name || '',
          a.name
        ].join('|');

        const bKey = [
          String(bParentNo).padStart(3, '0'),
          String(bChapterNo).padStart(3, '0'),
          bParentCov?.name || '',
          b.name
        ].join('|');

        return aKey.localeCompare(bKey);
      });
      loadExCovsBoardInfo();
    }

    function loadExCovsBoardInfo() {
      for (let ex_cov of IS_ex_coverage.value) {
        if (ex_cov.linked_ref) {
          getBoardInfoByIdx(ex_cov.linked_ref);
        }
      }
    }

    
    function openDialog(b) {
      use_dialog.value = b;
      if (!b) {
        editing_ex_cov.value = null; // 닫을 때만 초기화
        resetDialogPosition();
      } else {
        resetDialogPosition(); // 열 때 위치 초기화
      }
    }


    function openEditExCovDialog(b, ex_cov) {
      // 복제
      editing_ex_cov.value = null;
      if (ex_cov) {
        editing_ex_cov.value = JSON.parse(JSON.stringify(ex_cov));
      } else {
        editing_ex_cov.value = {
          idx: null,
          name: '새 보장',
          chapter_id: '',
          sel: 1,
          parent: null,
          suggestion: 0,
          is_union: 0,
          searchable: 0,
          tags: '',
          short_name: '',
          long_name: '',
          style_important: 0,
          style_bold: 0,
          calculable: 0,
          no: 0,
          r_bcr: 0,
          r_ncr: 0,
          r_w: 0,
          r_bcm: 0,
          r_wbs: 0,
          r_bia: 0,
          r_n: 0,
        };
      }
      use_dialog.value = b;
      watching_parent_chapter.value = getChapterById(ex_cov?.chapter_id)?.parent || '';
    }

    function getParentCov(parent) {
      if (!parent) return null;
      const parentCov = IS_ex_coverage.value.find(cov => cov.idx === parent);
      return parentCov;
    }

    // 순환 참조 안전 stringify 함수
    function stringifySafe(obj) {
      try {
        return JSON.stringify(toRaw(obj), null, 2);
      } catch (err) {
        return '[Circular structure]';
      }
    }

    function getChapterById(chapterId) {
      return IS_chapter.value.find(chapter => chapter.idx === chapterId);
    }

    function getChapterParentById(chapterId) {
      const chapter = IS_chapter.value.find(ch => ch.idx === chapterId);
      if (chapter && chapter.parent) {
        return IS_chapter.value.find(ch => ch.idx === chapter.parent);
      }
      return null;
    }

    function getChpaterChildrenById(chapterId) {
      return IS_chapter.value.filter(ch => ch.parent === chapterId);
    }


    const datasets = {
      IS_ex_coverage,
      IS_chapter
    };


        // benefit_type 관련 함수들
    function isBenefitSelected(benefitIdx) {
      if (!editing_ex_cov.value || !editing_ex_cov.value.benefit_type) return false;
      const types = editing_ex_cov.value.benefit_type.split('|').filter(t => t);
      return types.includes(String(benefitIdx));
    }

    function toggleBenefitType(benefitIdx) {
      if (!editing_ex_cov.value) return;
      
      let types = editing_ex_cov.value.benefit_type ? 
        editing_ex_cov.value.benefit_type.split('|').filter(t => t) : [];
      
      const idxStr = String(benefitIdx);
      
      if (types.includes(idxStr)) {
        // 제거
        types = types.filter(t => t !== idxStr);
      } else {
        // 추가
        types.push(idxStr);
      }
      
      editing_ex_cov.value.benefit_type = types.join('|');
    }

    function getBenefitTypeNames(benefitType) {
      if (!benefitType) return '--';
      const types = benefitType.split('|').filter(t => t);
      const names = types.map(idx => {
        const benefit = benefit_ex_list.value.find(b => b.idx == idx);
        return benefit ? benefit.name : idx;
      });
      return names.join(', ');
    }

    function getBenefitTypeNamesOnlyFirstLetter(benefitType) {
      if (!benefitType) return '--';
      const types = benefitType.split('|').filter(t => t);
      const names = types.map(idx => {
        const benefit = benefit_ex_list.value.find(b => b.idx == idx);
        return benefit ? benefit.name.slice(0,1) : idx;
      });
      return names.join(', ');
    }

    function getChpaterInfo(chapterId) {
      return IS_chapter.value.find(chapter => chapter.idx === chapterId);
    }

    function getCovInfo(covId) {
      return IS_ex_coverage.value.find(cov => cov.idx === covId);
    }

    // edit_ex_cov 저장
    async function saveEditingExCov() {
      if (!editing_ex_cov.value) return;
      console.log('saveEditingExCov', '저장시도');

      const ex_cov = editing_ex_cov.value;

      if (!ex_cov.chapter_id) {
        alert('카테고리를 선택해주세요');
        return;
      }

      // SQL 이스케이프 헬퍼 함수
      function escapeSQL(str) {
        if (!str) return '';
        return String(str).replace(/'/g, "''");
      }

      console.log('ex_cov', ex_cov);
      
      if (editing_ex_cov.value.idx) {
        // sql update
        await sql_query(`
          UPDATE IS_ex_coverage SET
            name = '${escapeSQL(ex_cov.name)}',
            short_name = '${escapeSQL(ex_cov.short_name)}',
            long_name = '${escapeSQL(ex_cov.long_name)}',
            chapter_id = '${escapeSQL(ex_cov.chapter_id)}',
            sel = ${ex_cov.sel ? 1 : 0},
            calculable = ${ex_cov.calculable ? 1 : 0},
            no = ${ex_cov.no || 0},
            parent = ${ex_cov.parent ? `'${escapeSQL(ex_cov.parent)}'` : 'NULL'},
            tags = '${escapeSQL(ex_cov.tags)}',
            benefit_type = '${escapeSQL(ex_cov.benefit_type || '')}',
            period_value = ${ex_cov.period_value || 0},
            period_type = '${escapeSQL(ex_cov.period_type || '세')}',
            renewable = ${ex_cov.renewable || 0},
            premium = ${ex_cov.premium || 0},
            is_union = ${ex_cov.is_union ? 1 : 0},
            searchable = ${ex_cov.searchable ? 1 : 0},
            suggestion = ${ex_cov.suggestion ? 1 : 0},
            description = '${escapeSQL(ex_cov.description || '')}',
            low_show = ${ex_cov.low_show ? 1 : 0},
            r_bcr = ${ex_cov.r_bcr || 0},
            r_ncr = ${ex_cov.r_ncr || 0},
            r_w = ${ex_cov.r_w || 0},
            r_bcm = ${ex_cov.r_bcm || 0},
            r_wbs = ${ex_cov.r_wbs || 0},
            r_bia = ${ex_cov.r_bia || 0},
            r_n = ${ex_cov.r_n || 0},
            style_important = ${ex_cov.style_important ? 1 : 0},
            style_bold = ${ex_cov.style_bold ? 1 : 0}
          WHERE idx = '${escapeSQL(ex_cov.idx)}'
        `);

      } else {
        // sql insert
        let sql = `
          INSERT INTO IS_ex_coverage SET
            name = '${escapeSQL(ex_cov.name)}',
            short_name = '${escapeSQL(ex_cov.short_name)}',
            long_name = '${escapeSQL(ex_cov.long_name)}',
            chapter_id = '${escapeSQL(ex_cov.chapter_id)}',
            sel = ${ex_cov.sel ? 1 : 0},
            calculable = ${ex_cov.calculable ? 1 : 0},
            no = ${ex_cov.no || 0},
            parent = ${ex_cov.parent ? `'${escapeSQL(ex_cov.parent)}'` : 'NULL'},
            tags = '${escapeSQL(ex_cov.tags)}',
            benefit_type = '${escapeSQL(ex_cov.benefit_type || '')}',
            period_value = ${ex_cov.period_value || 0},
            period_type = '${escapeSQL(ex_cov.period_type || '세')}',
            searchable = ${ex_cov.searchable ? 1 : 0},
            suggestion = ${ex_cov.suggestion ? 1 : 0},
            renewable = ${ex_cov.renewable || 0},
            premium = ${ex_cov.premium || 0},
            is_union = ${ex_cov.is_union ? 1 : 0},
            description = '${escapeSQL(ex_cov.description || '')}',
            low_show = ${ex_cov.low_show ? 1 : 0},
            r_bcr = ${ex_cov.r_bcr || 0},
            r_ncr = ${ex_cov.r_ncr || 0},
            r_w = ${ex_cov.r_w || 0},
            r_bcm = ${ex_cov.r_bcm || 0},
            r_wbs = ${ex_cov.r_wbs || 0},
            r_bia = ${ex_cov.r_bia || 0},
            r_n = ${ex_cov.r_n || 0},
            style_important = ${ex_cov.style_important ? 1 : 0},
            style_bold = ${ex_cov.style_bold ? 1 : 0}
        `;
        
        console.log(sql);
        await sql_query(sql);
      }

      
      editing_ex_cov.value = null; // 편집 모드 종료
      // 업데이트 후 데이터 새로 불러오기
      fetchData();
      // 대화창 닫기
      openDialog(false);
    }

    // 복제 기능 추가
    async function copyExCov(ex_cov) {
      if (!ex_cov || !ex_cov.idx) return;
      if (!confirm(`"${ex_cov.name}" 보장항목을 복제하시겠습니까?`)) {
        return;
      }

      // SQL 이스케이프 헬퍼 함수
      function escapeSQL(str) {
        if (!str) return '';
        return String(str).replace(/'/g, "''");
      }

      // 복제할 항목 생성 (idx 제외, 이름에 "(복사본)" 추가)
      const copiedName = ex_cov.name + ' (복사본)';
      
      try {
        // sql insert
        const sql = `
          INSERT INTO IS_ex_coverage SET
            name = '${escapeSQL(copiedName)}',
            short_name = '${escapeSQL(ex_cov.short_name)}',
            long_name = '${escapeSQL(ex_cov.long_name)}',
            chapter_id = '${escapeSQL(ex_cov.chapter_id)}',
            sel = ${ex_cov.sel ? 1 : 0},
            calculable = ${ex_cov.calculable ? 1 : 0},
            no = ${(ex_cov.no || 0) + 1},
            parent = ${ex_cov.parent ? `'${escapeSQL(ex_cov.parent)}'` : 'NULL'},
            tags = '${escapeSQL(ex_cov.tags)}',
            benefit_type = '${escapeSQL(ex_cov.benefit_type || '')}',
            period_value = ${ex_cov.period_value || 0},
            period_type = '${escapeSQL(ex_cov.period_type || '세')}',
            searchable = ${ex_cov.searchable ? 1 : 0},
            suggestion = ${ex_cov.suggestion ? 1 : 0},
            renewable = ${ex_cov.renewable || 0},
            premium = ${ex_cov.premium || 0},
            is_union = 0,
            description = '${escapeSQL(ex_cov.description || '')}',
            low_show = ${ex_cov.low_show ? 1 : 0},
            r_bcr = ${ex_cov.r_bcr || 0},
            r_ncr = ${ex_cov.r_ncr || 0},
            r_w = ${ex_cov.r_w || 0},
            r_bcm = ${ex_cov.r_bcm || 0},
            r_wbs = ${ex_cov.r_wbs || 0},
            r_bia = ${ex_cov.r_bia || 0},
            r_n = ${ex_cov.r_n || 0},
            style_important = ${ex_cov.style_important ? 1 : 0},
            style_bold = ${ex_cov.style_bold ? 1 : 0},
            linked_ref = ${ex_cov.linked_ref ? `'${escapeSQL(ex_cov.linked_ref)}'` : 'NULL'}
        `;
        
        await sql_query(sql);
        
        // 데이터 새로 불러오기
        fetchData();
        alert('복제되었습니다.');
      } catch (err) {
        console.error('Error copying ex_cov:', err);
        alert('복제 중 오류가 발생했습니다.');
      }
    }

    function delExCov(ex_cov) {
      if (!ex_cov || !ex_cov.idx) return;
      if (!confirm(`정말로 "${ex_cov.name}" 보장항목을 삭제하시겠습니까?`)) {
        return;
      }
      // sql delete
      sql_query(`DELETE FROM IS_ex_coverage WHERE idx = '${ex_cov.idx}'`)
        .then(() => {
          // 데이터 새로 불러오기
          fetchData();
        })
        .catch(err => {
          console.error('Error deleting ex_cov:', err);
        });
    }

    // editing_ex_cov.name 이름 중복확인
    async function checkNameDuplicate() {
      const name = editing_ex_cov.value.name;
      let sql = ` select * from IS_ex_coverage where name = '${name}'`;
      const result = await sql_query(sql);
      if (result.length > 0) {
        if (result.length == 1) {
          alert('중복 없음');
        } else {
          alert(`중복 있음 ${result.length-1}`);
        }
      }
    }

    // editing_ex_cov.no 중복확인
    async function checkNoDuplicate() {
      const no = editing_ex_cov.value.no;
      let sql = ` select * from IS_ex_coverage where no = ${no}`;
      const result = await sql_query(sql);
      if (result.length > 0) {
        if (result.length == 1) {
          alert('중복 없음');
        } else {
          alert(`중복 있음 ${result.length-1}`);
        }
      }
    }

    // 검색 기능
    function filterExCoverage() {
      if (!searchKeyword.value || searchKeyword.value.trim() === '') {
        filteredExCoverage.value = IS_ex_coverage.value;
        return;
      }

      const keyword = searchKeyword.value.toLowerCase().trim();
      
      filteredExCoverage.value = IS_ex_coverage.value.filter(cov => {
        // 이름으로 검색
        if (cov.name && cov.name.toLowerCase().includes(keyword)) return true;
        // 압축 이름으로 검색
        if (cov.short_name && cov.short_name.toLowerCase().includes(keyword)) return true;
        // 전체 이름으로 검색
        if (cov.long_name && cov.long_name.toLowerCase().includes(keyword)) return true;
        // 태그로 검색
        if (cov.tags && cov.tags.toLowerCase().includes(keyword)) return true;
        // 설명으로 검색
        if (cov.description && cov.description.toLowerCase().includes(keyword)) return true;
        
        return false;
      });
    }

    function clearSearch() {
      searchKeyword.value = '';
      filterExCoverage();
    }

    // 드래그 기능
    function startDrag(e) {
      isDragging.value = true;
      dragStart.value = {
        x: e.clientX - dialogPosition.value.x,
        y: e.clientY - dialogPosition.value.y
      };
      
      document.addEventListener('mousemove', onDrag);
      document.addEventListener('mouseup', stopDrag);
      e.preventDefault();
    }

    function onDrag(e) {
      if (!isDragging.value) return;
      
      dialogPosition.value = {
        x: e.clientX - dragStart.value.x,
        y: e.clientY - dragStart.value.y
      };
    }

    function stopDrag() {
      isDragging.value = false;
      document.removeEventListener('mousemove', onDrag);
      document.removeEventListener('mouseup', stopDrag);
    }

    function resetDialogPosition() {
      // 화면 중앙에 배치
      const windowWidth = window.innerWidth;
      const windowHeight = window.innerHeight;
      const dialogWidth = 600; // max-width
      const dialogHeight = window.innerHeight * 0.8; // 80%
      
      dialogPosition.value = {
        x: (windowWidth - dialogWidth) / 2,
        y: (windowHeight - dialogHeight) / 2
      };
    }


    return {
      datasets,
      use_dialog,
      IS_ex_coverage,
      IS_chapter,
      stringifySafe,
      getChapterById,
      editing_ex_cov,
      openDialog,
      openEditExCovDialog,
      saveEditingExCov,
      copyExCov,
      delExCov,
      getParentCov,
      getChapterParentById,
      IS_ex_coverage_filtered,
      IS_chapter_onlyChild,
      IS_chapter_onlyParent,
      showAllChapters,
      toggleAllChapters,
      getMbid,
      getChpaterChildrenById,
      use_boardPicker,
      showBoardPicker,
      handleBoardPicker,
      boardInfos,
      benefit_ex_list,
      isBenefitSelected,
      toggleBenefitType,
      getBenefitTypeNames,
      getChpaterInfo,
      watching_parent_chapter,
      selectedParentExCov,
      unionExCovList,
      notUnionExCovList,
      getCovInfo,
      getBenefitTypeNamesOnlyFirstLetter,
      checkNameDuplicate,
      checkNoDuplicate,
      searchKeyword,
      filteredExCoverage,
      filterExCoverage,
      clearSearch,
      dialogPosition,
      isDragging,
      startDrag,
      onDrag,
      stopDrag,
      resetDialogPosition
    };
  },
};

</script>


<style scoped>
.admin-CA-setting {
  width:100%;
  height: 100%;
  display:flex;
  flex-direction: column;
  justify-content: start;
  align-items: center;
  background-color: var(--color-background);
}

.admin-CA-setting > .header { 
  width: 100%;
  height: 60px;
  display: flex;
  justify-content: start;
  align-items: center;
  color: var(--color-text-primary);
  border-bottom: 1px solid var(--color-surface-reverse);
  padding:16px;
  box-sizing: border-box;
}


.dialog {
  width:100%;
  height:100%;
  position: absolute;
  left:0;
  top:0;
  background-color: rgba(0,0,0,0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9;
}

.dialog > .close {
  position: absolute;
  z-index: -1;
  right: 0;
  top: 0;
  width:100%;
  height:100%;
}

.dialog > .paper {
  position: absolute;
  width: 100%;
  max-width:600px;
  height: 80%;
  background-color: var(--color-background);
  border:1px solid var(--color-text-primary);
  border-radius: 16px;
  padding: 0;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  justify-content: start;
  align-items: start;
  gap:0;
  overflow:hidden;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3);
}

.dialog > .paper .dialog-header {
  width: 100%;
  height: 48px;
  background: var(--color-brand);
  color: var(--color-text-black);
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 16px;
  cursor: move;
  user-select: none;
  border-radius: 16px 16px 0 0;
  flex-shrink: 0;
}

.dialog > .paper .dialog-header:active {
  cursor: grabbing;
}

.dialog > .paper .dialog-header h2 {
  margin: 0;
  font-size: 16px;
  font-weight: 600;
}

.dialog > .paper .dialog-header .close-btn {
  background: transparent;
  border: none;
  color: var(--color-text-black);
  cursor: pointer;
  font-size: 20px;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  transition: background 0.2s;
}

.dialog > .paper .dialog-header .close-btn:hover {
  background: rgba(0, 0, 0, 0.1);
}

.dialog > .paper > .btns {
  width: 100%;
  height: fit-content;
  display: flex;
  flex-direction: row !important;
  justify-content: space-between;
  align-items: center;
  bottom:0;
  position: absolute;
  left:0;
  flex-shrink: 0;
  border-radius: 0 0 16px 16px;
  overflow: hidden;
}

.dialog > .paper > .btns > button {
  width: 100px;
  flex:1;
  height: 48px;
  border: none;
  background-color: var(--color-background-light);
  color: var(--color-text-primary);
  font-weight: 600;
  font-size:var(--font-size-md);
  cursor: pointer;
}
.dialog > .paper > .btns > button.a {
  background-color: var(--color-brand);
  color: var(--color-text-black);
}

.dialog > .paper.edit-ex-cov > ul {
  width: 100%;
  height: fit-content;
  display: flex;
  flex-direction: column;
  padding:16px;
  margin:0;
  list-style: none;
  gap:16px;
  padding-bottom: 120px;
  box-sizing: border-box;
  overflow:scroll;
  flex: 1;
}

.dialog > .paper.edit-ex-cov > ul::-webkit-scrollbar {
  display: none;
}

.dialog > .paper.edit-ex-cov > ul > li {
  position:relative;
  width: 100%;
  height: fit-content;
  display: flex;
  justify-content: center;
  align-items: start;
  gap: 6px;
  flex-direction: column;
}
.dialog > .paper.edit-ex-cov > ul > li > span {
  width: 100%;
  height: fit-content;
  color: var(--color-text-primary);
}

.dialog > .paper.edit-ex-cov > ul > li input[type="text"],
.dialog > .paper.edit-ex-cov > ul > li input[type="number"],
.dialog > .paper.edit-ex-cov > ul > li textarea,
.dialog > .paper.edit-ex-cov > ul > li select {
  width: 100%;
  height: 36px;
  padding: 0px 8px;
  box-sizing: border-box;
  border-radius: 4px;
  border: 1px solid var(--color-surface-reverse);
  background-color: var(--color-background-light);
}

.dialog > .paper.edit-ex-cov > ul > li textarea {
  height:80px;
}

.content {
  width:100%;
  height:100%;
  flex:1;
  padding:16px;
  box-sizing: border-box;
  display:flex;
  flex-direction: column;
  justify-content: start;
  align-items: start;
  gap:16px;
}

.item {
  font-size: 16px;
}

.IS_ex_coverage {
  width: 100%;
  height: fit-content;
  display: flex;
  flex-direction: column;
  background: var(--color-background-light);
  padding:16px;
  box-sizing: border-box;
  border-radius: 8px;
  gap:24px;
}

.IS_ex_coverage > .guide {
  width: 100%;
  height: 36px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: var(--color-text-primary);
  border: 1px solid var(--color-surface-reverse);
}

.IS_ex_coverage > .guide > span {
  width: 100%;
  height:100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex:4;
  text-align: center;
  font-weight: 600;
  border-right: 1px solid var(--color-surface-reverse);
  background: var(--color-background);
}

.IS_ex_coverage > .guide > span:last-child {
  border-right: none;
}

.IS_ex_coverage > .header {
  width: 100%;
  height: fit-content;
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: var(--color-text-primary);
}

.IS_ex_coverage > .header h2 {
  margin: 0px;
  color: var(--color-text-primary);
  font-size: 16px;
}

.IS_ex_coverage > ul {
  width:100%;
  height: 70vh;
  display: flex;
  flex-direction: column;
  padding:0;
  margin:0;
  list-style: none;
  overflow-y: scroll;


  border: 1px solid var(--color-surface-reverse);
}

.IS_ex_coverage > ul > li {
  width:100%;
  height: fit-content;
  display: flex;
  border-bottom: 1px solid var(--color-surface-reverse);
}

.IS_ex_coverage > ul > li:hover {
  background: var(--color-surface-reverse);
  cursor:pointer;
}

.IS_ex_coverage > ul > li > span {
  width: 100%;
  height: 36px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex:4;
  text-align: center;
  border-right: 1px solid var(--color-surface-reverse);
}

#btn_add { 
  width: fit-content;
  height: 38px;
  padding: 0 20px;
  border: none;
  background-color: var(--color-brand);
  color: var(--color-text-black);
  font-weight: 600;
  font-size:var(--font-size-md);
  cursor: pointer;
  border-radius: 8px;
  box-shadow: 0px 2px 4px rgba(0,0,0,0.1);
  display: flex;
  justify-content: center;
  align-items: center;
  white-space: nowrap;
}

.hot_bar {
  width:100%;
  display:flex;
  flex-direction: column;
  gap:6px;
}

.hot_bar > .all {
  width:100%;
  height: 36px;
  display:flex;
  flex-direction: row;
  justify-content: start;
  align-items: center;
}

.hot_bar > .con {
  width:100%;
  height: fit-content;
  display:flex;
  flex-direction: row;
  justify-content: start;
  align-items: start;
}

.hot_bar > .con > ul {
  width:100%;
  height: 100%;
  flex:1;
  display:flex;
  flex-direction: row;
  justify-content: start;
  align-items: start;
  padding:0;
  margin:0;
  list-style: none;
}

.hot_bar > .con > ul > li {
  flex:1;
  width: fit-content;
  height:100%;
  display:flex;
  flex-direction: column;
  justify-content: start;
  align-items: center;
  gap:8px;
  border:1px solid var(--color-surface-reverse);
}

.hot_bar > .con > ul > li > span {
  width: 100%;
  height: 24px;
  display:flex;
  justify-content: center;
  align-items: center;
  font-size: var(--font-size-md);
  color: var(--color-text-primary);
  border-bottom: 1px solid var(--color-surface-reverse);
}

.hot_bar > .con > ul > li > div {
  width: 100%;
  height: fit-content;
  display:flex;
  flex-direction: column;
  justify-content: start;
  align-items: start;
}

.search-box {
  position: relative;
  display: flex;
  align-items: center;
  background-color: var(--color-background);
  border: 1px solid var(--color-surface-reverse);
  border-radius: 8px;
  padding: 8px 12px;
  min-width: 300px;
}

.search-box i.ph-magnifying-glass {
  color: var(--color-surface-reverse);
  margin-right: 8px;
  font-size: 18px;
}

.search-box input {
  flex: 1;
  border: none;
  background: transparent;
  color: var(--color-text-primary);
  font-size: 14px;
  outline: none;
}

.search-box input::placeholder {
  color: var(--color-surface-reverse);
}

.search-box .clear-btn {
  background: none;
  border: none;
  color: var(--color-surface-reverse);
  cursor: pointer;
  padding: 0;
  margin-left: 8px;
  font-size: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.search-box .clear-btn:hover {
  color: var(--color-text-primary);
}

.copy, .remove {
  padding: 4px 8px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
  transition: all 0.2s;
}

.copy {
  background-color: var(--color-brand);
  color: var(--color-text-black);
}

.copy:hover {
  opacity: 0.8;
}

.remove {
  background-color: #ff4444;
  color: white;
}

.remove:hover {
  background-color: #cc0000;
}
</style>